import type { PromotionModuleOptions } from '@promotion/types'
import { useRuntimeConfig } from '#imports'

export const usePromotionConfig = (): PromotionModuleOptions => {
    const config = useRuntimeConfig()

    return config.public.promotion as PromotionModuleOptions
}
